import { infiniteQueryOptions, useInfiniteQuery } from "@tanstack/react-query";
import api from "~/shared/api/core/api";
import { Params } from "~/shared/api/types/params";
import { PaginatedResponse } from "~/shared/types/pagination.types";
import { createInfinitePaginationConfig } from "~/shared/util/createInfinitePaginationConfig";

const SKILLS_KEYS = {
  all: ["skills"] as const,
  list: (params: Params) => [...SKILLS_KEYS.all, "list", params] as const,
};

export const SKILLS_QUERIES = {
  infiniteList: (params: { [key: string]: unknown }) => {
    const paginationConfig = createInfinitePaginationConfig(params, 20);

    return infiniteQueryOptions({
      queryKey: SKILLS_KEYS.list({
        params: paginationConfig.keyParams,
      }),
      queryFn: async ({ pageParam = 1, signal }) => {
        const response = await api.get<
          PaginatedResponse<{
            id: number;
            name: string;
          }>
        >(`/skills`, {
          params: paginationConfig.queryFnParams(pageParam),
          signal,
        });

        return response.data;
      },
      ...paginationConfig.opts,
    });
  },
};

export function useInfiniteSkillsFilter(params: { [key: string]: unknown }) {
  return useInfiniteQuery(SKILLS_QUERIES.infiniteList(params));
}
